<ion-header class="modal-header">
  <ion-toolbar>
    <div class="modal-title">
      <h3>Insert Variable</h3>
    </div>
    <ion-buttons slot="end">
      <ion-button fill="clear" shape="round" class="close-button" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<div class="inner-content" style="padding: 5px 15px 15px">
  <div class="flexed" style="margin-bottom: 15px">
    <div
      class="round-pill-tab round-pill-tab-left"
      [ngClass]="{
        'round-pill-tab-active': !isLinkMode
      }"
      (click)="toggleTextMode()"
    >
      Text
    </div>
    <div
      class="round-pill-tab round-pill-tab-right"
      [ngClass]="{
        'round-pill-tab-active': isLinkMode
      }"
      (click)="toggleLinkMode()"
    >
      Link
    </div>
  </div>

  <div class="select-chip-container" style="margin-top: 0px" *ngIf="!isLinkMode">
    <ion-label class="input-label">Insert dynamic text from</ion-label>
    <ion-chip
      mode="ios"
      [outline]="true"
      class="select-chip select-outline"
      (click)="showCategoryOptions()"
      style="width: 100%"
    >
      <ion-label class="select-label">
        {{ selectedCategory?.title ?? 'None' }}
        <ion-icon name="chevron-down-outline" class="icon-padded-left"></ion-icon>
      </ion-label>
    </ion-chip>
  </div>

  <div class="select-chip-container" *ngIf="selectedCategory?.id === CATEGORIES.CONVERSATION.id || isLinkMode">
    <ion-label class="input-label" *ngIf="!isLinkMode">{{ CATEGORIES.CONVERSATION.label }}</ion-label>
    <ion-label class="input-label" *ngIf="isLinkMode">Insert dynamic link from</ion-label>
    <ion-chip mode="ios" [outline]="true" class="select-chip select-outline" (click)="showConversationFieldOptions()">
      <ion-label class="select-label">
        {{ selectedConversationField?.title ?? 'None' }}
        <ion-icon name="chevron-down-outline" class="icon-padded-left"></ion-icon>
      </ion-label>
    </ion-chip>
  </div>

  <div
    class="select-chip-container"
    *ngIf="selectedCategory?.id === CATEGORIES.CONVERSATION.id && selectedConversationField?.id === CUSTOM_FIELD_SIGIL"
  >
    <ion-label class="input-label">Custom Field</ion-label>
    <ion-chip mode="ios" [outline]="true" class="select-chip select-outline" (click)="showCustomFieldOptions()">
      <ion-label class="select-label">
        {{ selectedCustomField?.title ?? 'None' }}
        <ion-icon name="chevron-down-outline" class="icon-padded-left"></ion-icon>
      </ion-label>
    </ion-chip>
  </div>

  <div class="select-chip-container" *ngIf="selectedCategory?.id === CATEGORIES.AUTOMATION_INPUT.id">
    <ion-label class="input-label">Automation</ion-label>
    <ion-chip mode="ios" [outline]="true" class="select-chip select-outline" (click)="showAutomationOptions()">
      <ion-label class="select-label">
        {{ selectedAutomation?.title ?? 'None' }}
        <ion-icon name="chevron-down-outline" class="icon-padded-left"></ion-icon>
      </ion-label>
    </ion-chip>
  </div>

  <div
    class="select-chip-container"
    *ngIf="selectedAutomation && selectedCategory?.id === CATEGORIES.AUTOMATION_INPUT.id"
  >
    <ion-label class="input-label">{{ CATEGORIES.AUTOMATION_INPUT.label }}</ion-label>
    <ion-chip
      mode="ios"
      [outline]="true"
      class="select-chip select-outline"
      (click)="showAutomationInputFieldOptions()"
    >
      <ion-label class="select-label">
        {{ selectedAutomationInputField?.title ?? 'None' }}
        <ion-icon name="chevron-down-outline" class="icon-padded-left"></ion-icon>
      </ion-label>
    </ion-chip>
  </div>

  <div class="select-chip-container" *ngIf="selectedCategory?.id === CATEGORIES.TRIGGERING_USER.id">
    <ion-label class="input-label">{{ CATEGORIES.TRIGGERING_USER.label }}</ion-label>
    <ion-chip mode="ios" [outline]="true" class="select-chip select-outline" (click)="showTriggeringUserFieldOptions()">
      <ion-label class="select-label">
        {{ selectedTriggeringUserField?.title ?? 'None' }}
        <ion-icon name="chevron-down-outline" class="icon-padded-left"></ion-icon>
      </ion-label>
    </ion-chip>
  </div>

  <div class="select-chip-container" *ngIf="selectedCategory?.id === CATEGORIES.CHANNEL.id">
    <ion-label class="input-label">{{ CATEGORIES.CHANNEL.label }}</ion-label>
    <ion-chip mode="ios" [outline]="true" class="select-chip select-outline" (click)="showChannelFieldOptions()">
      <ion-label class="select-label">
        {{ selectedChannelField?.title ?? 'None' }}
        <ion-icon name="chevron-down-outline" class="icon-padded-left"></ion-icon>
      </ion-label>
    </ion-chip>
  </div>

  <ion-item-divider> </ion-item-divider>

  <ng-container *ngIf="selectedVariable?.type === 'link'">
    <div class="select-chip-container">
      <ion-label class="input-label">Link text type</ion-label>
      <ion-select [(ngModel)]="linkTextIsVariable" class="select-outline" interface="popover">
        <ion-select-option [value]="true">Variable</ion-select-option>
        <ion-select-option [value]="false">Static text</ion-select-option>
      </ion-select>
    </div>

    <div class="select-chip-container" *ngIf="linkTextIsVariable">
      <ion-label class="input-label">Link text</ion-label>
      <ion-chip mode="ios" [outline]="true" class="select-chip select-outline" (click)="showOptionsForLinkText()">
        <ion-label class="select-label">
          {{ variableLinkText?.label ?? 'None' }}
          <ion-icon name="chevron-down-outline" class="icon-padded-left"></ion-icon>
        </ion-label>
      </ion-chip>
    </div>

    <div class="select-chip-container" *ngIf="!linkTextIsVariable">
      <ion-label class="input-label">Link text</ion-label>
      <ion-input
        [(ngModel)]="staticLinkText"
        class="select-outline input-field"
        placeholder="e.g. Click here"
      ></ion-input>
    </div>
  </ng-container>

  <ion-footer class="footer ion-no-border">
    <ion-button (click)="insert()" [disabled]="!isValid()"> Insert </ion-button>
  </ion-footer>
</div>
